import type { SectionsAboutUsInfoComponent } from '@twisto/api-cms'

import { StrapiMedia } from '../../atoms'

import * as styles from './about-us-info.styles'

export const AboutUsInfo = ({
  title,
  description,
  src,
}: SectionsAboutUsInfoComponent) => (
  <section css={styles.wrap}>
    <div css={styles.text}>
      <div css={styles.title}>{title}</div>
      <div css={styles.desc}>{description}</div>
    </div>

    <StrapiMedia {...src} css={styles.img} />
  </section>
)
